module.exports = __webpack_public_path__ + "2acb60f2/img/verified-icon.f93bbc14.svg";